import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  EmbeddedViewRef,
  AfterViewInit,
  Input
} from '@angular/core';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { IConfig } from 'src/app/modules/core/interfaces/config';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { ESidebarPosition } from 'src/app/modules/sidebar/enumerables/sidebarPosition';
import { ESidebarState } from 'src/app/modules/sidebar/enumerables/sidebarState';
import { NavbarOptionSoundComponent } from '../navbar-option-sound/navbar-option-sound.component';
import { NavbarOptionProfileComponent } from '../navbar-option-profile/navbar-option-profile.component';
import { NavbarChangeSystemComponent } from '../navbar-change-system/navbar-change-system.component';

@Component({
  selector: 'app-default-navbar',
  templateUrl: './default-navbar.component.html',
  styleUrls: ['./default-navbar.component.scss']
})
export class DefaultNavbarComponent implements OnInit, AfterViewInit {

  @Input()
  public hideOptions: boolean;

  @ViewChild('optionContainer', { read: ElementRef, static: false })
  private optionContainer: ElementRef;

  public config: IConfig;
  public navbarOptions: any[];

  constructor(
    public configService: ConfigService,
    public sidebarService: StateSidebarService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {
    this.navbarOptions = [
      NavbarOptionSoundComponent,
      NavbarChangeSystemComponent,
      NavbarOptionProfileComponent,
    ];
  }

  /**
   * App initialize
   */
  public ngOnInit(): void {
    this.config = this.configService.getConfig();
  }

  /**
   * Until the view is initialized
   */
  public ngAfterViewInit(): void {
    if (!this.hideOptions) {
      this.addComponentsToOptions();
    } else {
      this.addProfileToOptions();
    }
  }

  /**
   * Function to set state to sidebar
   * @param state: Sidebar state
   */
  public setSidebarState(state: ESidebarState): void {
    this.sidebarService.setState(state);
  }

  /**
   * Function to set sidebar position
   * @param position: Sidebar position
   */
  public setSidebarPosition(position: ESidebarPosition): void {
    this.sidebarService.setPosition(position);
  }

  /**
   * Function which adds the components in navbarOptions inside html
   */
  public addComponentsToOptions(): void {
    for (const component of this.navbarOptions) {
      const componentRef = this.componentFactoryResolver
        .resolveComponentFactory(component)
        .create(this.injector);

      this.appRef.attachView(componentRef.hostView);

      const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      this.optionContainer.nativeElement.appendChild(domElem);
    }
  }

  /**
   * Function which adds the components in navbarOptions inside html
   */
  public addProfileToOptions(): void {
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(NavbarOptionProfileComponent)
      .create(this.injector);

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    this.optionContainer.nativeElement.appendChild(domElem);
  }

}
